<div class="cart-icon-wrapper" [ngStyle]="getIconStyles()">
    <span class="icon-counter" [ngStyle]="getCounterStyles()">1</span>
    <div [innerHTML]="getIcon(iconType.value)" [ngStyle]="previewIconSizeStyle()" class="icon"></div>
</div>
